import { clientWithoutInterceptors } from '../utils/http';
import { htmlLlmInsight, llmInsight } from '../types/insight';
import { OtsJobConfig } from '../services/otsConfigService';
import DDLogs from '../DDLogs';

export async function getOtsResultsByJobId(jobId: string): Promise<llmInsight[] | htmlLlmInsight[]> {
  try {
    const response = await clientWithoutInterceptors.get(`/api/ots-results/${jobId}`);

    // check if response status is 204 (no insights yet)
    if (response.status === 204) {
      DDLogs.info('No ots results found');
      return [];
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return response.data.sort((a: llmInsight, b: llmInsight) => a.index - b.index);
  } catch (error) {
    throw new Error('Could not get ots results');
  }
}

export async function getJobConfigById(jobId?:string): Promise<OtsJobConfig> {
  const response = await clientWithoutInterceptors.get(`/api/llm-jobs/${jobId}`);
  if (response.status !== 200) {
    throw new Error('Could not get job config');
  }

  return response.data;
}

export async function getAllOtsFlowConfigs(): Promise<OtsJobConfig[]> {
  const response = await clientWithoutInterceptors.get('/api/llm-jobs');
  if (response.status !== 200) {
    throw new Error('Could not get job configs');
  }

  return response.data;
}
